/**
 * Standort einer gebuchten Ferienwoche für die Anzeige auflösen (#1063).
 *
 * Den Standort gibt die Schule vor, nicht die Anmeldung: Trägt die
 * Ferienbetreuung der Schule die Woche noch, gewinnt deren Eintrag — ändert die
 * Verwaltung dort den Standort, sehen ihn auch Eltern mit einer bestehenden
 * Anmeldung. Der Snapshot in der Anmeldung ist nur der Rückfall für Wochen, die
 * es in der Konfiguration nicht mehr gibt.
 *
 * Bewusst nicht in `holiday-care-cost.utils.ts`: die Functions rechnen den
 * Standort beim Speichern aus der Konfiguration und brauchen diese reine
 * Anzeige-Regel nicht — die Datei dort ist eine Kopie und bleibt es.
 */
import type {
  HolidayCareLocation,
  VacationWeek,
} from '../models/holiday-care-registration.model';
import { resolveWeekLocation } from './holiday-care-cost.utils';

/** Woche mit Standort-Snapshot, wie sie in einer Anmeldung steht. */
interface BookedWeekLike {
  weekNumber: number;
  location?: HolidayCareLocation | null;
}

/**
 * Standort einer gebuchten Woche: aus der Ferienbetreuung der Schule, sonst aus
 * dem Snapshot der Anmeldung. `null` = Standort noch offen.
 */
export function resolveDisplayLocation(
  bookedWeek: BookedWeekLike,
  configuredWeeks: VacationWeek[] | undefined,
  ownSchool: { id: string; schoolName: string }
): HolidayCareLocation | null {
  const configured = configuredWeeks?.find(
    (week) => week?.weekNumber === bookedWeek.weekNumber
  );
  return resolveWeekLocation(configured ?? bookedWeek, ownSchool);
}
